import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "profile-group-filled",
  "use": "profile-group-filled-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"profile-group-filled\"><path d=\"M2.5 5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm6 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm1 8c.5 0 .5-.5.5-.5V12s0-4-4-4H4c-4 0-4 4-4 4v.5s0 .5.5.5h9z\" /><path d=\"M9.869 8h2.043C16 8 16 12 16 12v.5s0 .5-.51.5h-4.242a.73.73 0 00.113-.33v-.55S11.35 9.09 9 8.07c.266-.04.552-.07.869-.07z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol